import {Loading} from "../../utils/helpers/constants";
import * as FinanceConstants from "../constants/finance.constants";

const initialState = {
	banks: [],
	wallets: [],
	activityLogs: [],
	wallet: {},
	usersWallet: [],
	walletEntries: [],
	walletUserEntries: [],
	saasEntries: [],
	saasRecords: [],
	advancedPayments: [],
	withdrawalEntries: [],
	deliveryCollections: [],
	invoices: [],
	swiftPayments: [],
	swiftPayment: {},
	swiftPaymentConfigs: [],
	swiftPaymentConfig: {},
	swiftPaymentsCount: "",
	swiftPaymentConfigsCount: "",
	loadingSwiftPayments:"",
	loadingSwiftPaymentInfo: "",
	loadingSwiftPaymentConfigs: "",
	loadingSwiftPaymentConfigInfo: "",
	quickTopUps: [],
	quickTopUp: {},
	quickTopUpsCount: 0,
	loadingQuickTopUps: "",
	loadingQuickTopUpInfo: "",
	loadingBanks: "",
	loadingActivityLogs: [],
	sassEntriesCount: "",
	advancedPaymentsCount: "",
	activityLogsCount: "",
	loadingWallets: "",
	loadingWallet: "",
	loadingOrganisationUsersWallet: "",
	loadingWalletEntries: "",
	loadingWalletUserEntries: "",
	organisationWalletCount: "",
	withdrawalEntriesCount: "",
	deliveryCollectionsCount: "",
	invoicesCount: 0,
	invoicesPage: 1,
	invoicesLimit: 10,
	organisationUsersWalletCount: "",
	organisationUsersEntriesCount: "",
	organisationEntriesCount: "",
	loadingSaaSRecords: "",
	loadingSaaSEntries: "",
	loadingWithdrawalEntries: "",
	loadingDeliveryCollections: "",
	loadingInvoices: "",
	loadingAdvancedPayments: "",
	
};

const financeReducers = (state = initialState, action) => {
	switch(action.type) {
		case FinanceConstants.FETCH_BANKS_REQUEST:
			return {...state, loadingBanks: Loading.FETCHING};

		case FinanceConstants.FETCH_BANKS_SUCCESS:
			return {...state, loadingBanks: Loading.SUCCESS, banks: action.payload};

		case FinanceConstants.FETCH_BANKS_FAILURE:
			return {...state, loadingBanks: Loading.ERROR};

		case FinanceConstants.FETCH_WALLETS_REQUEST:
			return {...state, loadingWallets: Loading.FETCHING};

		case FinanceConstants.FETCH_WALLETS_SUCCESS:
			return {
				...state,
				loadingWallets: Loading.SUCCESS,
				organisationWalletCount: action.payload.count,
				wallets: action.payload.data
			};

		case FinanceConstants.FETCH_WALLETS_FAILURE:
			return {...state, loadingWallets: Loading.ERROR};

		case FinanceConstants.FETCH_WALLET_REQUEST:
			return {...state, loadingWallet: Loading.FETCHING};

		case FinanceConstants.FETCH_WALLET_SUCCESS:
			return {...state, loadingWallet: Loading.SUCCESS, wallet: action.payload};

		case FinanceConstants.FETCH_WALLET_FAILURE:
			return {...state, loadingWallet: Loading.ERROR};

		case FinanceConstants.FETCH_ORGANISATION_USERS_REQUEST:
			return {...state, loadingOrganisationUsersWallet: Loading.FETCHING};

		case FinanceConstants.FETCH_ORGANISATION_USERS_SUCCESS:
			return {
				...state,
				loadingOrganisationUsersWallet: Loading.SUCCESS,
				organisationUsersWalletCount: action.payload.count,
				usersWallet: action.payload.data
			};

		case FinanceConstants.FETCH_ORGANISATION_USERS_FAILURE:
			return {...state, loadingOrganisationUsersWallet: Loading.ERROR};

		case FinanceConstants.FETCH_ORGANISATION_WALLET_ENTRIES_REQUEST:
			return {...state, loadingWalletEntries: Loading.FETCHING};

		case FinanceConstants.FETCH_ORGANISATION_WALLET_ENTRIES_SUCCESS:
			return {
				...state, loadingWalletEntries: Loading.SUCCESS,
				organisationEntriesCount: action.payload.count, walletEntries: action.payload.data
			};

		case FinanceConstants.FETCH_ORGANISATION_WALLET_ENTRIES_FAILURE:
			return {...state, loadingWalletEntries: Loading.ERROR};

		case FinanceConstants.FETCH_ORGANISATION_USER_ENTRIES_REQUEST:
			return {...state, loadingWalletUserEntries: Loading.FETCHING};

		case FinanceConstants.FETCH_ORGANISATION_USER_ENTRIES_SUCCESS:
			return {
				...state,
				loadingWalletUserEntries: Loading.SUCCESS,
				organisationUsersEntriesCount: action.payload.count,
				walletUserEntries: action.payload.data
			};

		case FinanceConstants.FETCH_ORGANISATION_USER_ENTRIES_FAILURE:
			return {...state, loadingWalletUserEntries: Loading.ERROR};

		case FinanceConstants.FETCH_SASS_ENTRIES_REQUEST:
			return {...state, loadingSaaSEntries: Loading.FETCHING};

		case FinanceConstants.FETCH_SASS_ENTRIES_SUCCESS:
			return {
				...state,
				loadingSaaSEntries: Loading.SUCCESS,
				saasEntries: action.payload.data,
				sassEntriesCount: action.payload.count
			};

		case FinanceConstants.FETCH_SASS_ENTRIES_FAILURE:
			return {...state, loadingSaaSEntries: Loading.ERROR};

		case FinanceConstants.FETCH_SAAS_RECORDS_REQUEST:
			return {...state, loadingSaaSRecords: Loading.FETCHING};

		case FinanceConstants.FETCH_SAAS_RECORDS_SUCCESS:
			return {...state, loadingSaaSRecords: Loading.SUCCESS, saasRecords: action.payload};

		case FinanceConstants.FETCH_SAAS_RECORDS_FAILURE:
			return {...state, loadingSaaSRecords: Loading.ERROR};

		case FinanceConstants.FETCH_WITHDRAWAL_ENTRIES_REQUEST:
			return {...state, loadingWithdrawalEntries: Loading.FETCHING};

		case FinanceConstants.FETCH_WITHDRAWAL_ENTRIES_SUCCESS:
			return {
				...state, loadingWithdrawalEntries: Loading.SUCCESS,
				withdrawalEntries: action.payload.data, withdrawalEntriesCount: action.payload.count
			};

		case FinanceConstants.FETCH_WITHDRAWAL_ENTRIES_FAILURE:
			return {...state, loadingWithdrawalEntries: Loading.ERROR};

		case FinanceConstants.FETCH_DELIVERY_COLLECTIONS_REQUEST:
			return {...state, loadingDeliveryCollections: Loading.FETCHING};

		case FinanceConstants.FETCH_DELIVERY_COLLECTIONS_SUCCESS:
			return {
				...state, loadingDeliveryCollections: Loading.SUCCESS,
				deliveryCollections: action.payload.data, deliveryCollectionsCount: action.payload.count
			};

		case FinanceConstants.FETCH_DELIVERY_COLLECTIONS_FAILURE:
			return {...state, loadingDeliveryCollections: Loading.ERROR};

		case FinanceConstants.FETCH_INVOICES_REQUEST:
			return {...state, loadingInvoices: Loading.FETCHING};

		case FinanceConstants.FETCH_INVOICES_SUCCESS:
			return {
				...state,
				loadingInvoices: Loading.SUCCESS,
				invoices: action.payload.data,
				invoicesCount: action.payload.count,
				invoicesPage: action.payload.page,
				invoicesLimit: action.payload.limit,
			};

		case FinanceConstants.FETCH_INVOICES_FAILURE:
			return {...state, loadingInvoices: Loading.ERROR};

		case FinanceConstants.REMOVE_INVOICE_FROM_STORE:
			return {
				...state,
				invoices: state.invoices.filter(invoice => (
					`${invoice.invoice_id ?? invoice.invoice_number ?? invoice.id}` !== `${action.payload}`
				)),
				invoicesCount: Math.max(0, Number(state.invoicesCount) - 1),
			};

		case FinanceConstants.UPDATE_INVOICE_IN_STORE:
			return {
				...state,
				invoices: state.invoices.map(invoice => {
					const currentReference = invoice.invoice_id ?? invoice.invoice_number ?? invoice.id;
					const updatedReference = action.payload.invoice_id
						?? action.payload.invoice_number
						?? action.payload.id;
					return `${currentReference}` === `${updatedReference}`
						? {...invoice, ...action.payload}
						: invoice;
				}),
			};



		case FinanceConstants.FETCH_ADVANCED_PAYMENTS_REQUEST:
			return {...state, loadingAdvancedPayments: Loading.FETCHING};

		case FinanceConstants.FETCH_ADVANCED_PAYMENTS_SUCCESS:
			return {
				...state, loadingAdvancedPayments: Loading.SUCCESS,
				advancedPayments: action.payload.data,
				advancedPaymentsCount: action.payload.count
			};

		case FinanceConstants.FETCH_ADVANCED_PAYMENTS_FAILURE:
			return {...state, loadingAdvancedPayments: Loading.ERROR, 
				advancedPayments: initialState.advancedPayments, 
				advancedPaymentsCount: initialState.advancedPaymentsCount
			};

		case FinanceConstants.FETCH_ACTIVITY_LOG_REQUEST:
			return { ...state, loadingActivityLogs: Loading.FETCHING };

		case FinanceConstants.FETCH_ACTIVITY_LOG_SUCCESS:
			return {
				...state, loadingActivityLogs: Loading.SUCCESS,
				activityLogs: action.payload.data,
				activityLogsCount: action.payload.count
			};

		case FinanceConstants.FETCH_ACTIVITY_LOG_FAILURE:
			return {
				...state, loadingActivityLogs: Loading.ERROR,
				activityLogs: initialState.activityLogs,
				activityLogsCount: initialState.activityLogsCount
			};
		case FinanceConstants.FETCH_SWIFT_PAYMENTS_REQUEST:
			return {...state, loadingSwiftPayments: Loading.FETCHING};
		case FinanceConstants.FETCH_SWIFT_PAYMENTS_SUCCESS:
			return {
				...state, loadingSwiftPayments: Loading.SUCCESS,
				swiftPayments: action.payload.data,
				swiftPaymentsCount: action.payload.count
			};

		case FinanceConstants.FETCH_SWIFT_PAYMENTS_FAILURE:
			return {...state, loadingSwiftPayments: Loading.ERROR, 
				swiftPayments: initialState.swiftPayments, 
				swiftPaymentsCount: initialState.swiftPaymentsCount
			};

		case FinanceConstants.FETCH_SWIFT_PAYMENT_DETAILS_REQUEST:
			return {...state, loadingSwiftPaymentInfo: Loading.FETCHING};
		case FinanceConstants.FETCH_SWIFT_PAYMENT_DETAILS_SUCCESS:
			let swiftPayment = typeof action.payload === "object" && action.payload !== null ? action.payload : {}
			let swiftPayments = Array.isArray(state.swiftPayments) ? state.swiftPayments.map(item => {
				const isMatchingPayment = (item?.id && swiftPayment?.id && item.id === swiftPayment.id)
					|| (item?.reference && swiftPayment?.reference && item.reference === swiftPayment.reference);
				return isMatchingPayment ? {...item, ...swiftPayment} : item;
			}) : state.swiftPayments;
			return {...state, loadingSwiftPaymentInfo: Loading.SUCCESS , swiftPayment, swiftPayments};

		case FinanceConstants.FETCH_SWIFT_PAYMENT_DETAILS_FAILURE:
			return {...state, loadingSwiftPaymentInfo: Loading.ERROR };

		case FinanceConstants.FETCH_QUICK_TOP_UPS_REQUEST:
			return {...state, loadingQuickTopUps: Loading.FETCHING};
		case FinanceConstants.FETCH_QUICK_TOP_UPS_SUCCESS:
			return {
				...state,
				loadingQuickTopUps: Loading.SUCCESS,
				quickTopUps: Array.isArray(action.payload?.data) ? action.payload.data : [],
				quickTopUpsCount: action.payload?.count ?? 0,
			};
		case FinanceConstants.FETCH_QUICK_TOP_UPS_FAILURE:
			return {
				...state,
				loadingQuickTopUps: Loading.ERROR,
				quickTopUps: initialState.quickTopUps,
				quickTopUpsCount: initialState.quickTopUpsCount,
			};

		case FinanceConstants.FETCH_QUICK_TOP_UP_DETAILS_REQUEST:
			return {...state, loadingQuickTopUpInfo: Loading.FETCHING};
		case FinanceConstants.FETCH_QUICK_TOP_UP_DETAILS_SUCCESS: {
			const quickTopUp = typeof action.payload === "object" && action.payload !== null ? action.payload : {};
			const quickTopUps = state.quickTopUps.map(item => {
				const isMatchingRequest = (item?.id && quickTopUp?.id && item.id === quickTopUp.id)
					|| (item?.reference && quickTopUp?.reference && item.reference === quickTopUp.reference);
				return isMatchingRequest ? {...item, ...quickTopUp} : item;
			});
			return {...state, loadingQuickTopUpInfo: Loading.SUCCESS, quickTopUp, quickTopUps};
		}
		case FinanceConstants.FETCH_QUICK_TOP_UP_DETAILS_FAILURE:
			return {...state, loadingQuickTopUpInfo: Loading.ERROR, quickTopUp: initialState.quickTopUp};

		
		case FinanceConstants.FETCH_SWIFT_PAYMENT_CONFIGS_REQUEST:
			return {...state, loadingSwiftPaymentConfigs: Loading.FETCHING};
		case FinanceConstants.FETCH_SWIFT_PAYMENT_CONFIGS_SUCCESS:
			return {
				...state, loadingSwiftPaymentConfigs: Loading.SUCCESS,
				swiftPaymentConfigs: action.payload.data,
				swiftPaymentConfigsCount: action.payload.count
			};

		case FinanceConstants.FETCH_SWIFT_PAYMENT_CONFIGS_FAILURE:
			return {...state, loadingSwiftPaymentConfigs: Loading.ERROR, 
				swiftPaymentConfigs: initialState.swiftPaymentConfigs, 
				swiftPaymentConfigsCount: initialState.swiftPaymentConfigsCount
			};

		case FinanceConstants.FETCH_SWIFT_PAYMENT_CONFIG_DETAILS_REQUEST:
			return {...state, loadingSwiftPaymentConfigInfo: Loading.FETCHING};
		case FinanceConstants.FETCH_SWIFT_PAYMENT_CONFIG_DETAILS_SUCCESS:
			let swiftPaymentConfig = typeof action.payload === "object" && action.payload !== null ? action.payload : {}
			return {...state, loadingSwiftPaymentConfigInfo: Loading.SUCCESS , swiftPaymentConfig};

		case FinanceConstants.FETCH_SWIFT_PAYMENT_CONFIG_DETAILS_FAILURE:
			return {...state, loadingSwiftPaymentConfigInfo: Loading.ERROR };



		
		case 'RESET_STATE':
			return initialState;

		default:
			return state;
	}
};

export default financeReducers;
